import { useEffect, useState } from 'react'

export function useAnalytics() {
  const [sent, setSent] = useState(false)

  return {
    sendOnLoad: (cb) => {
      if (sent) {
        return
      }
      setSent(true)
      cb()
    },
  }
}

export function useSendOnceWithDeps(dep, cb) {
  const [sent, setSent] = useState(false)

  useEffect(() => {
    if (dep && !sent) {
      setSent(true)
      cb()
    }
  }, [dep, cb, sent])
}
